<template>
  <div>
    <!-- Header (Inspinia-style) -->
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2 class="page-title mb-0">Study Insights</h2>
      </div>
    </div>

    <div class="wrapper wrapper-content p-0 mt-2">
        <!-- Metrics -->
        <div class="metrics-row mb-2">
          <div class="" v-for="m in metricsAll" :key="m.key">
            <div class="card metric-tile shadow-sm h-100">
              <div class="card-body d-flex align-items-center justify-content-start">
                <div class="metric-icon" :class="m.bg">
                  <i :class="m.fa"></i>
                </div>
                <div class="ml-3">
                  <div class="metric-label">{{ m.label }}</div>
                </div>
                <div class="mr-3 ms-auto">
                  <div class="metric-value float-right">{{ m.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Studies Overview -->
        <div class="card mb-2">
          <div class="card-header bg-white">
            <div class="studies-header">
              <div class="studies-title">                
                <span>Study Overview</span>
              </div>
            </div>
          </div>

          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table align-middle mb-0 studies-table">
                <thead>
                  <tr>
                    <th class="pl-3" style="min-width: 140px;">Study</th>
                    <th style="min-width: 120px;">Site Code</th>
                    <th style="min-width: 360px;">Enrollment</th>
                    <th class="text-nowrap">Expected</th>
                    <th class="text-nowrap">Enrolled</th>
                    <th class="text-nowrap">Completed</th>
                    <th class="text-nowrap">Withdrawn</th>
                    <th class="text-nowrap pr-3">Screening Failed</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="s in privilagedsites" :key="s.siteId + '-' + s.studyId">
                    <td class="pl-3">
                      <div class="font-bold">{{ s.studyRef || "-" }}</div>
                    </td>

                    <td>
                      <div class="font-bold">{{ s.siteCode || "-" }}</div>
                    </td>

                    <!-- Enrollment progress -->
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="progress enroll-progress mr-2">
                          <div
                            class="progress-bar"
                            :class="progressBarClass(enrollmentPercentSite(s))"
                            :style="{ width: enrollmentPercentSite(s) + '%' }"
                          ></div>
                        </div>

                        <div class="text-nowrap small">
                          <template v-if="hasExpectedTotal(s)">
                            {{ Number(s.actullyEnrolled) || 0 }}/{{ Number(s.expectedTotalSubjects) || 0 }}
                            ({{ enrollmentPercentSite(s) }}%)
                          </template>
                          <template v-else>
                            {{ Number(s.actullyEnrolled) || 0 }} enrolled (Target N/A)
                          </template>
                        </div>
                      </div>
                    </td>

                    <td class="text-nowrap">
                      {{ hasExpectedTotal(s) ? Number(s.expectedTotalSubjects) : "-" }}
                    </td>

                    <td class="text-nowrap">
                      {{ Number(s.actullyEnrolled) || 0 }}
                    </td>

                    <td class="text-nowrap">
                      {{ Number(s.completed) || 0 }}
                    </td>

                    <td class="text-nowrap">
                      {{ Number(s.withdrawn) || 0 }}
                    </td>

                    <td class="text-nowrap pr-3">
                      {{ Number(s.screeningFailed) || 0 }}
                    </td>
                  </tr>

                  <tr v-if="!privilagedsites || privilagedsites.length === 0">
                    <td colspan="10" class="text-center text-muted py-4">
                      No studies/sites found.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Site Performance -->
        <!-- <div class="card shadow-sm mb-3">
          <div class="card-header bg-white">
            <div class="studies-header">
              <div class="studies-title">
                <span>Site Performance</span>
              </div>
            </div>
          </div>

          <div class="card-body p-0">
            <div class="table-responsive" :class="{ 'scrollable-table': performanceList.length > 10 }">
              <table class="table align-middle mb-0 studies-table">
                <thead>
                  <tr>
                    <th class="text-center">Rank</th>
                    <th class="text-center">SiteCode</th>
                    <th class="text-center">Average Risk Score</th>
                    <th class="text-center">Total KPIs Analysed</th>
                    <th class="text-center">Run Date</th>
                    <th class="text-center">View</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in performanceList" :key="list.id">
                    <td class="text-center">{{ list.rank }}</td>
                    <td class="text-center">{{ list.siteCode }}</td>
                    <td class="text-center">
                      <div :class="customcolor(list.averageRiskScore)" class="d-inline-block">
                        {{ list.averageRiskScore }}
                      </div>
                    </td>
                    <td class="text-center">{{ list.totalKPIsAnalysed }}</td>
                    <td class="text-center">{{ formatRunDate(list.runDate) }}</td>
                    <td class="text-center">
                      <a @click.prevent="viewDocument(list.kpiWithScores, list.siteId, list.siteCode)">
                        <i class="fas fa-eye edit-delete"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="!performanceList || performanceList.length === 0">
                    <td colspan="6" class="text-center text-muted py-4">
                      No site performance data found.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> -->

    </div>

    <monitor-kpi-modal
      v-if="openModal"
      :kpiwithscores="kpiWithScores"
      @closeModal="closeModal"
      @opencreateschdulemodel="opencreateschdule"
    />
    <CreateSchedulePopup
      v-if="createschedulemodel"
      :siteId="siteId"
      :sitecode="siteCodeforpopup"
      @closescheduleModal="createschedulemodel = false"
    />
  </div>
</template>

<script src="./Site_Overview.js"></script>

<style scoped>
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css");

/* Heading typography */
.page-title {
  font-size: 30px;
  font-weight: 600;
}

.metrics-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
}
.metrics-col {
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 15px;
  width: 100%;
}
@media (min-width: 576px) {
  .metrics-col { width: 50%; }
}
@media (min-width: 992px) {
  .metrics-col { width: 25%; } /* 4 in a row */
}

/* Metric cards */
.metric-tile {
  border-radius: 12px;
}
.metric-icon {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
}
.metric-label {
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
}
.metric-value {
  font-size: 32px;
  font-weight: 600;
  line-height: 1.1;
  color: #4e4e4e;
}

/* Colored metric squares */
.bg-blue-soft { background: #0d6efd; }
.bg-green-soft { background: #198754; }
.bg-yellow-soft { background: #ffc107; }
.bg-red-soft { background: #dc3545; }
.bg-secondary-soft { background: #6c757d; }

/* Studies header alignment */
.studies-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.studies-title {
  font-size: 14px;
  font-weight: 600;
  color: #111;
  display: flex;
  align-items: center;
}
.studies-filters {
  margin-left: auto;
}

/* Table look */
.studies-table thead th {
  font-weight: 700;
  color: #111;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  padding-top: 5px;
  padding-bottom: 5px;
  white-space: nowrap;
}
.studies-table tbody td {
  border-top: 1px solid #f0f0f0;
  padding-top: 5px;
  padding-bottom: 5px;
  vertical-align: top;
}

/* Enrollment bar */
.enroll-progress {
  height: 8px;
  min-width: 320px;
  background: #e9ecef;
  border-radius: 999px;
  overflow: hidden;
}
.enroll-progress .progress-bar {
  min-width: 2px;
  border-radius: 999px;
}

/* Action button */
.action-btn {
  border-radius: 6px;
  font-weight: 700;
}

.scrollable-table {
  max-height: 420px;
  overflow-y: auto;
}

.highrisk {
  background-color: #f22613;
}

.mediumrisk {
  background-color: #f5d76e;
}

.safe {
  background-color: #87d37c;
}

.inround {
  min-width: 52px;
  padding: 2px 8px;
  border-radius: 10%;
  text-align: center;
}
.card-body{
  padding:5px 5px;
}
</style>
